import ErnstigeBloedingenOnderDoacDabigatran from "../../../../src/client/lta-antistolling/ernstige-bloedingen-onder-doac-dabigatran.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  ErnstigeBloedingenOnderDoacDabigatran,
  ChartCollapse,
  React
};